// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
/**
 * Exception details of the exception in a chain.
 */
var ExceptionDetails = /** @class */ (function () {
    function ExceptionDetails() {
        /**
         * Indicates if full exception stack is provided in the exception. The stack may be trimmed, such as in the case of a StackOverflow exception.
         */
        this.hasFullStack = true;
        /**
         * List of stack frames. Either stack or parsedStack should have a value.
         */
        this.parsedStack = [];
    }
    return ExceptionDetails;
}());
export { ExceptionDetails };
//# sourceMappingURL=ExceptionDetails.js.map